export const MaterialType = {
  PAPER: 'Papel',
  PLASTIC: 'Plástico',
  GLASS: 'Vidro',
  METAL: 'Metal',
};

export const MaterialTypeKey = {
  PAPER: 'paper',
  PLASTIC: 'plastic',
  GLASS: 'glass',
  METAL: 'metal',
};
